import script from "./InvoicePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePreview.vue?vue&type=script&setup=true&lang=js"

import "./InvoicePreview.vue?vue&type=style&index=0&id=9c2c16b6&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c2c16b6"]])

export default __exports__